import React from 'react';
import styled from 'styled-components';

const HorizontalLineStyle = styled.hr`
  width: 100%;
  height: 7px;
  border: 0 none;
  margin-right: auto;
  margin-left: auto;
  margin-top: 20px;
  margin-bottom: 90px;
  background-color: var(--gray-1);
`;

export default function HorizontalLine() {
  return (
    <div>
      <HorizontalLineStyle className="line" />
    </div>
  );
}
